import Route from '@ember/routing/route';

export default class AuthenticatedCareerPathwaysFinanceRoute extends Route {}
